<template>
  <div class="w-full items-start">
    <lf-input
      :value="link"
      class="truncate"
      name="link"
      :show-label="false"
      :placeholder="placeholder"
      readonly
      no-margin
    >
      <template #suffix>
        <copy-button
          :text="link"
          data-cy="widget-link-copy-btn"
          :is-loading="loading"
        >
          <icon-base
            class="my-1 place-self-center"
            height="20"
            width="20"
            :icon="IconCopy"
            :icon-name="$t('COMMON.COPY')"
          />
        </copy-button>
      </template>
    </lf-input>
  </div>
</template>
<script>
import IconCopy from "@/components/icons/IconCopy.vue";
import CopyButton from "@/components/ui/buttons/CopyButton.vue";

export default {
  components: {
    CopyButton,
  },
  props: {
    link: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { IconCopy };
  },
};
</script>
